var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appGrey pa-4"},[_c('app-text',[_vm._v(_vm._s(_vm.eventData.eventStaffInstructions))]),_c('v-divider',{staticClass:"mt-4"}),_c('app-btn',{staticClass:"mt-4",attrs:{"block":true,"label":"Close"},nativeOn:{"click":function($event){return _vm.$emit('emitCloseEventAvailabilityCardStaffInstructionsDialog')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }